import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { payPlanMobx, payChannelMobx } from '@mobx/mall/payment'
import { sortBy } from '@dt/fe-utils/dist/lodash'
import { modalLayer } from '@utils'
import BankCardOnline from './BankCardOnline/MethodItem'
import ApplePayWeb from './ApplePayWeb/MethodItem'
import PaypalMethodItem from './PayPalWeb/PayPalMethodItem'
import AlipayMethodItem from './Alipay/MethodItem'
import WechatPay from './WechatPay/MethodItem'
import MemberCardPay from './MemberCardPay'
import ExternalPayNone from './ExternalPayNone'
import GiftCardPay from './GiftCardPay'
import './index.scss'

const Pay = () => {
  const list = useMemo(() => {
    return sortBy(payChannelMobx.availableMethods, v => payChannelMobx.channelSortMap?.[v]?.sort === undefined ? 9999 : payChannelMobx.channelSortMap?.[v]?.sort)
  }, [payChannelMobx.availableMethods, payChannelMobx.channelSortMap])

  return (
    <div className='mall-checkout-pay'>
      <div className='actual-pay-amount'>
        <div>{i18n.t('pay.paymentMethod')}</div>
        <div onClick={() => modalLayer.closeAll()}>
          <i className='iconfont icon-close'></i>
        </div>
      </div>
      <div>
        {payPlanMobx.totalAmount > 0 && (
          <>
            {
              list?.map(x => {
                if (x === 'BankCardOnline') {
                  const method = payPlanMobx.payMethods.find(x => x.type === 'BankCardOnline') as IBankCardOnlinePayMethod
                  return <BankCardOnline key={x} method={method} selected={payPlanMobx.externalMethod?.type === x} />
                } else if (x === 'ApplePayWeb') {
                  return <ApplePayWeb key={x} selected={payPlanMobx.externalMethod?.type === x} />
                } else if (x === 'PayPalWeb') {
                  return <PaypalMethodItem key={x} selected={payPlanMobx.externalMethod?.type === x} />
                } else if (x === 'AlipayApp') {
                  return <AlipayMethodItem key={x} selected={payPlanMobx.externalMethod?.type === x} />
                } else if (x === 'WechatPayWeb') {
                  return <WechatPay key={x} selected={payPlanMobx.externalMethod?.type === x} />
                } else if (x === 'MemberCard') {
                  return <MemberCardPay key={x} />
                } else if (x === 'GiftCard') {
                  return <GiftCardPay key={x} />
                }
              })
            }
            <ExternalPayNone />
          </>
        )}
      </div>
    </div>
  )
}

export default observer(Pay)
